import React from 'react';
import border from '../img/border.png';
import * as d3 from 'd3';
import {Icon, List, Modal, Drawer, Descriptions, Divider, Button} from 'antd';

const maxScale = 5, minScale = 0.5;

const imageBorder = 6;
const width = document.documentElement.clientWidth * 0.68;//68vw
const height = document.documentElement.clientHeight * 0.85;//85vh
const width_vw = '68vw';
const height_vh = '85vh';

function genLinkPath(link) {
    let sx = link.source.x;
    let tx = link.target.x;
    let sy = link.source.y;
    let ty = link.target.y;
    return 'M' + sx + ',' + sy + ' L' + tx + ',' + ty
}

function labelTranslate(link) {
    let sx = link.source.x;
    let tx = link.target.x;
    let sy = link.source.y;
    let ty = link.target.y;
    if (sx > tx) {
        let temp = sx;
        sx = tx;
        tx = temp;
        temp = sy;
        sy = ty;
        ty = temp;
    }

    const x = tx - sx;
    const y = ty - sy;
    const r = Math.atan2(y, x) * 180 / Math.PI;
    return 'translate(' + (sx + tx) / 2 + ',' + (sy + ty) / 2 + ') rotate(' + r + ')';
}

function tick() {
    d3.select('g.node-group').selectAll('g.node')
        .attr('transform', node => {
            return 'translate(' + node.x + ',' + node.y + ')'
        });
    d3.select('g.link-group').selectAll('path.link')
        .attr('d', genLinkPath);
    d3.select('g.link-group').selectAll('g.entityRelation')
        .attr('transform', labelTranslate);
    d3.select('g.selected-node-group').selectAll('g.node')
        .attr('transform', node => {
            return 'translate(' + node.x + ',' + node.y + ')'
        });
    d3.select('g.selected-link-group').selectAll('path.link')
        .attr('d', genLinkPath);
    d3.select('g.selected-link-group').selectAll('g.entityRelation')
        .attr('transform', labelTranslate);
}

export default class EntityGraph extends React.Component {

    state = {
        visible: false,
        label1: '',
        label2: '',
        sentences: [],
        drawerVisible: false,
        infoboxTitle: '',
        infoboxProperties: [],
        infoboxRelations: [],
    };


    showDrawer = (node) => {
        if (node.size === 'tiny') {
            return
        }
        const {selectedEntitiesEdges, unSelectedEntitiesEdges, events} = this.props;

        const eventsMap = {};
        events.forEach(event => {
            eventsMap[event.index] = event;
        });
        node['eventIndex'].forEach(i => {
            const svg = d3.select('#event-index' + (eventsMap[i].index + 1));
            svg.transition()
                .ease('linear')
                .duration(500)
                .attr('width', 0);
        })

        const mention = node.mention;
        const allEdges = selectedEntitiesEdges.concat(unSelectedEntitiesEdges);
        const infoboxRelations = [];
        allEdges.forEach(edge => {
            const sourceMention = edge.source.mention;
            const targetMention = edge.target.mention;
            if (mention === sourceMention) {
                infoboxRelations.push(edge)
            }
            if (mention === targetMention) {
                let temp = edge.source;
                edge.source = edge.target;
                edge.target = temp;
                infoboxRelations.push(edge)
            }
        });
        this.setState({
            drawerVisible: true,
            infoboxTitle: mention,
            infoboxProperties: node.propertyList,
            infoboxRelations: infoboxRelations,
        });

    };

    onClose = () => {
        this.setState({
            drawerVisible: false,
        });
    };

    showModal = (text, e1, e2) => {
        this.setState({
            visible: true,
            sentences: text,
            label1: e1,
            label2: e2
        })
    };

    hideModal = () => {
        this.setState({
            visible: false
        })
    };

    componentDidMount() {
        this.initFrame();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            selectedEntitiesEdges, unSelectedEntitiesEdges,
            selectedEntities, unSelectedEntities
        } = this.props;
        const allEntities = selectedEntities.concat(unSelectedEntities);
        const allEdges = selectedEntitiesEdges.concat(unSelectedEntitiesEdges);
        // 力导向图
        const force = d3.layout.force();
        force.size([width, height])
            .nodes(allEntities)
            .links(allEdges)
            .on('tick', tick)
            .friction(0.8)
            .linkDistance(function (link) {
                return link.weight * 6;
            }).linkStrength(0.2)
            .charge(-4000)
            .gravity(0.5);

        const prevAllEntities = prevProps.selectedEntities.concat(prevProps.unSelectedEntities);
        const prevAllEdges = prevProps.selectedEntitiesEdges.concat(prevProps.unSelectedEntitiesEdges);

        // 处理显示modal框造成的抖动
        if ((prevState.visible === this.state.visible)
            // 处理点击高亮造成的抖动
            && (prevAllEntities.length !== allEntities && allEdges.length !== prevAllEdges.length)
        ) {

            force.start();
        }
        this.drawEntity(force);
    }

    initFrame = () => {
        // 全图缩放器
        const zoom = d3.behavior.zoom()
            .scaleExtent([minScale, maxScale])
            .on('zoom', () => {
                const {translate} = d3.event;
                container.attr('transform', 'translate(' + translate + ')')
            });
        d3.select('#entityGraph>svg').remove();
        const svg = d3.select('#entityGraph')
            .append('svg')
            .attr('width', width - imageBorder * 2)
            .attr('height', height - imageBorder * 2)
            .style('position', 'absolute')
            .style('right', imageBorder)
            .style('top', imageBorder);


        //用于获取缩放事件
        svg.append('rect')
            .attr('class', 'zoom-rect')
            .attr('width', width - imageBorder * 2)
            .attr('height', height - imageBorder * 2)
            .style('fill', 'rgba(0,0,0,0)')
            .call(zoom);

        const container = svg.append('g').attr('class', 'container').attr('transform', 'translate(0,0)scale(1)');
        container.append('g').attr('class', 'link-group');
        container.append('g').attr('class', 'node-group');
        container.append('g').attr('class', 'selected-link-group');
        container.append('g').attr('class', 'selected-node-group');

        //绘制title
        svg.append('text')
            .attr('x', 26)
            .attr('y', 42)
            .style('fill', 'rgb(25,66,74)')
            .style('font-family', 'SourceHanSansCN-Regular')
            .style('font-size', 18)
            .style('line-height', 36)
            .style('letter-spacing', 0.9)
            .text('背景关系图谱');
        svg.append('line')
            .attr('x1', 26)
            .attr('x2', 146)
            .attr('y1', 56)
            .attr('y2', 56)
            .style('stroke', '#3eb2d7')
            .style('stroke-width', 6);

        svg.append('defs').attr('id', 'imgdefs');

    };

    drawUnSelectNode = (unSelectedEntities, drag) => {

        const nodeUpdate = d3.select('g.node-group').selectAll('.node')
            .data(unSelectedEntities);
        nodeUpdate.exit().remove();

        nodeUpdate
            .attr('class', node => 'node index' + node.i)
            .attr('transform', node => {
                return 'translate(' + node.x + ',' + node.y + ')'
            });
        nodeUpdate.selectAll('text').remove();
        nodeUpdate.selectAll('path').remove();
        nodeUpdate.selectAll('circle').remove();
        nodeUpdate.selectAll('image').remove();
        this.drawSubTag(nodeUpdate, false);
        this.nodeMaskAttr(nodeUpdate.insert('circle'));


        const nodeGroup = nodeUpdate.enter()
            .insert('g')
            .attr('class', node => 'node index' + node.i)
            .attr('transform', node => {
                return 'translate(' + node.x + ',' + node.y + ')'
            })
            .call(drag)
            .on('click', this.showDrawer);

        this.drawSubTag(nodeGroup, false);
        this.nodeMaskAttr(nodeGroup.insert('circle'))

    };

    drawSelectNode = (selectedEntities, drag) => {
        const nodeUpdate = d3.select('g.selected-node-group').selectAll('.node')
            .data(selectedEntities);
        // 删除减少的标签
        nodeUpdate.exit().remove();

        // 更新已有标签
        nodeUpdate
            .attr('class', node => 'node index' + node.i)
            .attr('transform', node => {
                return 'translate(' + node.x + ',' + node.y + ')'
            });

        nodeUpdate.selectAll('text').remove();
        nodeUpdate.selectAll('path').remove();
        nodeUpdate.selectAll('circle').remove();
        nodeUpdate.selectAll('image').remove();
        this.drawSubTag(nodeUpdate, true);


        // 获取新标签
        const nodeGroup = nodeUpdate.enter()
            .insert('g')
            .attr('class', node => 'node index' + node.i)
            .attr('transform', node => {
                return 'translate(' + node.x + ',' + node.y + ')'
            })
            .call(drag)
            .on('click', this.showDrawer);

        this.drawSubTag(nodeGroup, true);
    };

    drawEdge = (selectedEntitiesEdges, flag, cssselecter) => {
        const linkGroup = d3.select(cssselecter);
        //连接线和文字
        linkGroup.selectAll('g.link').remove();
        const link = linkGroup.selectAll('g.link')
            .data(selectedEntitiesEdges)
            .enter()
            .append('g')
            .attr('class', 'link')
            .on('click', this.edgeOnClick);

        link.insert('path')
            .style('stroke', link => {
                if (link.hasOwnProperty('sentences')) {
                    if (flag) {
                        return 'rgb(204,204,204)';
                    }
                    if (link.selected) {
                        return 'rgb(204,204,204)';
                    } else {
                        return '#646464';
                    }
                } else {
                    return '#646464';
                }
            })
            .style('stroke-width', link => {
                if (link.selected) {
                    return 3;
                } else {
                    return 1;
                }
            })
            .style('cursor', 'pointer')
            .attr('class', (link, index) => 'link link-index' + index)
            .attr('id', link => link.source.mention + '-' + link.target.mention + '-' + link.relation)
            .attr('d', genLinkPath);

        const relationGroup = link.append('g')
            .attr('class', 'entityRelation')
            .attr('transform', labelTranslate);
        relationGroup.append('rect')
            .attr('x', d => d.relation.length * -4 - 4)
            .attr('y', -6)
            .style('fill', '#000')
            .style('stroke', 'rgba(192, 192, 192, 0.5)')
            .style('stroke-width', 1)
            .attr('height', 12)
            .attr('width', d => {
                if (d.hasOwnProperty('sentences')) {
                    return 0;
                } else {
                    return d.relation.length * 8 + 8;
                }
            })
            .attr('rx', 9);
        relationGroup.append('text')
            .attr('x', d => d.relation.length * -4)
            .attr('y', 3)
            .style('fill', '#ff7f0e')
            .style('font-size', 8)
            .style('text-anchor', 'start')
            .text(d => d.relation);
    };

    drawSubTag = (nodeGroup, selected) => {
        this.nodeCircleAttr(nodeGroup.insert('circle'));
        this.nodeIconAttr(nodeGroup.insert('image'));
        this.nodeImageAttr(nodeGroup.insert('circle'));
        this.nodeTextAttr(nodeGroup.insert('text'), selected);
        // this.nodeMenuAttr(nodeGroup);
    };

    // 节点底色和边框
    nodeCircleAttr = (svgObj) => {
        svgObj.style('fill', node => global.nodeConf.iconFill[node.category])
            .style('stroke', node => global.nodeConf.iconBorder[node.category])
            .style('stroke-width', node => global.nodeConf[node.size].borderSize)
            .attr('class', 'node-circle')
            .attr('r', node => global.nodeConf[node.size].nodeRadio)
            .style('cursor', 'pointer');
    };

    // 节点图标
    nodeIconAttr = (svgObj) => {
        svgObj.attr('height', node => global.nodeConf[node.size].iconRadio * 2)
            .attr('width', node => global.nodeConf[node.size].iconRadio * 2)
            .attr('x', node => global.nodeConf[node.size].iconRadio * -1)
            .attr('y', node => global.nodeConf[node.size].iconRadio * -1)
            .attr('xlink:href', node => {
                if (node.image && node.image.length > 0) {
                    return null;
                } else {
                    return global.nodeConf.icon[node.category];
                }
            })
            .style('cursor', 'pointer');
    };

    // 节点图片
    nodeImageAttr = (svgObj) => {
        svgObj.attr('class', 'circleImg')
            .attr('r', node => global.nodeConf[node.size].nodeRadio)
            .style('stroke', node => global.nodeConf.iconBorder[node.category])
            .style('stroke-width', node => global.nodeConf[node.size].borderSize)
            .attr('fill', node => {
                const catpattern = d3.select('#imgdefs').append('pattern')
                    .attr('id', 'catpattern' + node.i)
                    .attr('height', 1)
                    .attr('width', 1);
                if (node.image && node.image.length > 0) {
                    catpattern.append('image')
                        .attr('height', global.nodeConf[node.size].nodeRadio * 2)
                        .attr('width', global.nodeConf[node.size].nodeRadio * 2)
                        .attr('xlink:href', node.image);

                }
                return 'url(#catpattern' + node.i + ')';

            })
            .style('cursor', 'pointer');
    };

    // 节点菜单
    nodeMenuAttr = (svgObj) => {
        const arc = d3.svg.arc().innerRadius(40).outerRadius(80);
        svgObj.selectAll('path.menu')
            .data(d3.layout.pie()([1, 1, 1]))
            .enter()
            .append('path')
            .style('visibility', 'hidden')
            .attr('class', 'menu')
            .attr('fill', '#DADBD5')
            .attr('stroke', '#969696')
            .attr('stroke-width', 3)
            .attr('d', arc)
    };

    // 节点文字
    nodeTextAttr = (svgObj, selected) => {
        svgObj.attr('class', (node, index) => 'nodeText node-mask node-mask-index' + index)
            .style('fill', () => {
                if (selected) {
                    return '#b4e4ff'
                } else {
                    return 'rgba(192, 192, 192, 0.5)';
                }
            })
            .style('font-size', node => global.nodeConf[node.size].fontSize)
            .style('font-family', 'SourceHanSansCN-Regular')
            .style('font-weight', 'normal')
            .attr('text-anchor', 'middle')
            .attr('y', node => global.nodeConf[node.size].nodeRadio + global.nodeConf[node.size].borderSize + 15)
            .text(node => node.mention)
            .style('cursor', 'pointer');
    };

    // 节点遮罩
    nodeMaskAttr = (svgObj) => {
        svgObj.style('fill', 'rgba(50,50,50,0.7)')
            .style('stroke', 'rgba(50,50,50,0.7)')
            .style('stroke-width', node => global.nodeConf[node.size].borderSize + 1)
            .attr('class', 'node-mask')
            .attr('r', node => global.nodeConf[node.size].nodeRadio)
            .style('cursor', 'pointer');
    };

    // 共现边点击效果
    edgeOnClick = (edge) => {
        const label1 = edge.source.mention;
        const label2 = edge.target.mention;

        if (edge.hasOwnProperty('sentences')) {
            edge.sentences.forEach(item => {
                let sentence = item.sentence + '...';
                sentence.replace(/\s+/g, '');
                sentence = sentence.replace(label1, `<span style="color: #ff7f0e">${label1}</span>`);
                sentence = sentence.replace(label2, `<span style="color: #ff7f0e">${label2}</span>`);
                item.sentence = sentence;
            });
        }
        this.showModal(edge.sentences, label1, label2)
    };

    drawEntity = (force) => {
        const {entities} = this.props;

        let selectedEntities = [];
        let unSelectedEntities = [];
        force.nodes().forEach(node => {
            if (node.selected) {
                selectedEntities.push(node);
            } else {
                unSelectedEntities.push(node);
            }
        });

        let selectedEntitiesEdge = [];
        let unSelectedEntitiesEdge = [];
        force.links().forEach(edge => {
            if (edge.selected) {
                selectedEntitiesEdge.push(edge);
            } else {
                unSelectedEntitiesEdge.push(edge);
            }
        });

        const drag = force.drag()
            .origin(d => d)
            .on('dragstart', function () {
                d3.event.sourceEvent.stopPropagation();
            })
            .on('drag', function () {
                force.start();

                d3.select(this)
                    .attr('transform', 'translate(' + d3.event.x + ',' + d3.event.y + ')')
            }).on('dragend', function () {
                // force.stop();
            });

        //全不选状态
        let flag = false;
        if (selectedEntitiesEdge.length === 0 && unSelectedEntitiesEdge.length > 0 &&
            selectedEntities.length === 0 && unSelectedEntities.length > 0) {

            let temp = selectedEntitiesEdge;
            selectedEntitiesEdge = unSelectedEntitiesEdge;
            unSelectedEntitiesEdge = temp;

            temp = selectedEntities;
            selectedEntities = unSelectedEntities;
            unSelectedEntities = temp;

            flag = true;
        }
        this.drawUnSelectNode(unSelectedEntities, drag);
        this.drawSelectNode(selectedEntities, drag);

        this.drawEdge(selectedEntitiesEdge, flag, 'g.selected-link-group');
        this.drawEdge(unSelectedEntitiesEdge, flag, 'g.link-group');

        // 事件标号
        entities.forEach(entity => {
            const eventColor = entity.eventColor;
            const data = eventColor.map((color, index) => {
                const indexAngle = global.nodeConf[entity.size].indexAngle;
                const angle = ((index + 1) % 2 === 0 ? 1 : -1) * (Math.floor((index + 1) / 2) * indexAngle + 180) - 90;
                const r = global.nodeConf[entity.size].nodeRadio;
                const x1 = r * Math.cos(angle * Math.PI / 180);
                const y1 = r * Math.sin(angle * Math.PI / 180);
                return {
                    size: entity.size,
                    color: color,
                    value: 1,
                    entityIndex: entity.i,
                    x: x1,
                    y: y1,
                    eventIndex: entity.eventIndex[index]
                }
            });
            d3.select('g.node.index' + entity.i).selectAll('g.indexNode').remove();
            const indexNode = d3.select('g.node.index' + entity.i)
                .selectAll('g.indexNode')
                .data(data)
                .enter()
                .append('g')
                .attr('class', 'indexNode');

            indexNode.append('circle')
                .attr('r', data => global.nodeConf[data.size].indexRadio)
                .attr('fill', data => data.color)
                .attr('transform', data => {
                    return 'translate(' + data.x + ',' + data.y + ')'
                });

            if (!(entity.selected || flag)) {
                //遮罩
                indexNode.append('circle')
                    .attr('r', data => global.nodeConf[data.size].indexRadio)
                    .attr('fill', 'rgba(50,50,50,0.7)')
                    .attr('transform', data => {
                        return 'translate(' + data.x + ',' + data.y + ')'
                    });
            }

            indexNode.append('text')
                .style('fill', '#000')
                .style('font-size', data => global.nodeConf[data.size].indexNumSize)
                .attr('text-anchor', 'middle')
                .attr('x', data => data.x)
                .attr('y', data => data.y + global.nodeConf[data.size].indexNumSize / 2)
                .text((data) => {
                    return data.eventIndex + 1;
                });
        });
    };

    render() {
        const {
            label1, label2, visible, sentences,
            infoboxTitle, drawerVisible, infoboxProperties, infoboxRelations
        } = this.state;
        const newsIdMap = this.props.newsIdMap
        const modalWidth = 800;
        return <div id={'entityGraph'} style={{
            position: 'absolute',
            left: '30vw',
            top: '10vh',
            width: width_vw,
            height: height_vh,
            overflow: 'hidden'
        }}>
            <img src={border} alt={'背景框'} style={{width: width_vw, height: height_vh}}/>
            <Drawer
                title={infoboxTitle}
                placement="right"
                closable={false}
                onClose={this.onClose}
                visible={drawerVisible}
                getContainer={false}
                destroyOnClose={true}
                style={{position: 'absolute'}}
            >
                {infoboxProperties.length > 0 ? <List
                    header={'实体信息'}
                    footer={null}
                    split={false}
                    dataSource={infoboxProperties}
                    renderItem={item => (
                        <List size={'small'}>
                            <List.Item>
                                <Descriptions>
                                    <Descriptions.Item label={item.key}>{item.value}</Descriptions.Item>
                                </Descriptions>
                            </List.Item>
                        </List>
                    )}
                /> : null}
                <Divider/>
                {infoboxRelations.length > 0 ? <List
                    header={'关联关系'}
                    footer={null}
                    split={false}
                    dataSource={infoboxRelations}
                    renderItem={item => (
                        <List size={'small'}>
                            <List.Item>
                                <Button type="link" onClick={() => this.edgeOnClick(item)}>
                                    {item.source.mention}
                                    --->
                                    {item.target.mention}
                                </Button>
                            </List.Item>
                        </List>
                    )}
                /> : null}
            </Drawer>

            <Modal
                title={label1 + ' - ' + label2}
                visible={visible}
                onCancel={this.hideModal}
                footer={null}
                destroyOnClose
                width={modalWidth}
            >
                <List
                    itemLayout='vertical'
                    size='large'
                    pagination={{
                        pageSize: 5,
                    }}
                    dataSource={sentences}
                    footer={null}
                    renderItem={item => (
                        <List.Item>
                            <a style={{color: '#000'}} href={item.url} target={'_blank'}
                               dangerouslySetInnerHTML={{__html: item.sentence}}/>
                            <div>
                                <div style={{
                                    color: '#A9A9A9',
                                    marginTop: 5,
                                    fontSize: 8,
                                    float: 'left',
                                    width: (modalWidth - 48) * 0.55
                                }}>
                                    <Icon type='snippets' style={{marginRight: 8}}/>
                                    {item.title}
                                </div>
                                <div style={{
                                    color: '#A9A9A9',
                                    marginTop: 5,
                                    textAlign: 'right',
                                    fontSize: 8,
                                    float: 'right',
                                    width: (modalWidth - 48) * 0.4
                                }}>
                                    {item.id ? <span>事件编号：
                                        {newsIdMap[item.id]}</span> : null}
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <Icon type='global' style={{marginRight: 8}}/>
                                    {item.publisher}
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <Icon type='clock-circle' style={{marginRight: 8}}/>
                                    {item.publishTime}
                                </div>
                                <div style={{clear: 'both'}}/>
                            </div>
                        </List.Item>
                    )}
                />
            </Modal>
        </div>
    }
}